import { AxiosError } from 'axios';

import { parseISO } from 'date-fns';

import { HousekeepApiErrorResponse } from '../models';

export const isAxiosError = function (candidate: any): candidate is AxiosError<HousekeepApiErrorResponse> {
  return candidate.isAxiosError === true;
};

export const shuffle = <T>(array: T[]): T[] => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

export const preventPaste = (e: Event) => {
  e.preventDefault();
  return false;
};

/**
 * Replaces all ocurrences of `search` in `find_in` with `replace`
 * e.g replaceAll("A cat attacked another cat last night", "cat", "dog")
 * "A dog attacked another dog last night"
 *
 * An unfortunate necessity since we cannot use the
 * now supported replaceAll built-in.
 * Useless from node 15 onward
 */
export function replaceAll(findIn: string, search: string, replace: string) {
  return findIn.split(search).join(replace);
}

/**
 * Returns the input as a date if typescript has failed to automatically cast it to a date
 */
export function ensureValueIsDate(val: Date | string): Date {
  return typeof val === 'string' ? parseISO(val) : val;
}
